import {
    EPISODE_STARTED,
    EPISODE_FINISHED,
    SHOW_ACCESSED,
    RESET_RECOMMENDATIONS,
} from '../actions/recommendation';

import {ADD_SHOW_FAVOURITE, REMOVE_SHOW_FAVOURITE} from '../actions/favourite';
import {USER_LOGOUT} from '../actions/user';

const initialState = {
    videos: {},
    shows: {},
};

export default function recommendationReducer(state = initialState, action) {
    switch (action.type) {
        case EPISODE_STARTED: {
            let video = getSavedVideo(action.video, state.videos);
            video.timesStarted += 1;
            let videos = {...state.videos, [video.id]: video};
            return {...state, videos};
        }
        case EPISODE_FINISHED: {
            let video = getSavedVideo(action.video, state.videos);
            video.timesEnded += 1;
            let videos = {...state.videos, [video.id]: video};
            return {...state, videos};
        }
        case SHOW_ACCESSED: {
            let show = getSavedShow(action.show, state.shows);
            show.timesAccessed += 1;
            let shows = {...state.shows, [show.id]: show};
            return {...state, shows};
        }
        case ADD_SHOW_FAVOURITE: {
            let show = getSavedShow(action.payload, state.shows);
            show.isFavorite = true;
            let shows = {...state.shows, [show.id]: show};
            return {...state, shows};
        }
        case REMOVE_SHOW_FAVOURITE: {
            let show = getSavedShow(action.payload, state.shows);
            show.isFavorite = false;
            let shows = {...state.shows, [show.id]: show};
            return {...state, shows};
        }
        case RESET_RECOMMENDATIONS:
        case USER_LOGOUT: {
            return initialState;
        }
        default: {
            return state;
        }
    }
}

const getSavedVideo = (video, videos) => {
    var savedVideo = videos[video.id];
    if (!savedVideo) {
        savedVideo = asSavedVideo(video);
    }
    savedVideo.lastUpdate = new Date().getTime();
    return savedVideo;
};

const asSavedVideo = object => {
    return {
        id: object.id,
        showId: object.show?.id,
        season: object.season,
        episode: object.episode,
        duration: object.duration,
        time: 0,
        timesStarted: 0,
        timesEnded: 0,
        lastUpdate: 0,
    };
};

const getSavedShow = (show, shows) => {
    let savedShow = shows[show.id];
    if (!savedShow) {
        return asSavedShow(show);
    }
    return savedShow;
};

const asSavedShow = show => {
    return {
        id: show.id,
        timesAccessed: 0,
        isFavorite: false,
    };
};
